import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M18 11a5 5 0 1 0 0 10 5 5 0 0 0 0-10m-1.927 3.427L17.646 16l-1.573 1.573c-.236.236.118.59.354.354L18 16.354l1.573 1.573c.236.236.59-.118.354-.354L18.354 16l1.573-1.573c.235-.236-.118-.59-.354-.354L18 15.646l-1.573-1.573c-.236-.236-.59.118-.354.354M2.526 6A.514.514 0 0 0 2 6.5c0 .276.236.5.526.5h18.948c.29 0 .526-.224.526-.5s-.236-.5-.526-.5zM2.5 10a.5.5 0 0 0 0 1h10.601a7 7 0 0 1 1.291-1zm8.79 8q.155.519.384 1H2.5a.5.5 0 0 1 0-1zm0-4q-.145.486-.22 1H2.5a.5.5 0 0 1 0-1z",
      clipRule: "evenodd"
    }
  )
);
var SvgTranscriptionErrorOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var TranscriptionErrorOutlined_default = SvgTranscriptionErrorOutlined;

export { TranscriptionErrorOutlined_default as default };
